import { render, staticRenderFns } from "./localeRouterView.vue?vue&type=template&id=db74932a&scoped=true&"
import script from "./localeRouterView.vue?vue&type=script&lang=js&"
export * from "./localeRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db74932a",
  null
  
)

export default component.exports